module.exports = __webpack_public_path__ + "img/findex_logo_white_dash.2ede80d8.png";